export default __webpack_public_path__ + "tradein.659e149b.svg";